import Vue from "vue";
import { isArray, first } from "lodash";

export default Vue.extend({
  props: ["target", "errorClass", "showClass"],
  // template:
  //     '<div class="invalid-feedback" v-show="show" v-text="text"></div>',
  computed: {
    show() {
      return this.target != undefined;
    },
    text() {
      if (this.target && isArray(this.target)) {
        return first(this.target);
      } else {
        return this.target;
      }
    },
    formErrorClass() {
      return this.errorClass ? this.errorClass : "form-error";
    },
  },
  render: function(h) {
    return h(
      "span",
      {
        class: [this.formErrorClass, this.showClass],
        style: {
          display: this.show ? "" : "none",
        },
      },
      this.text
    );
  },
});
